export function rejectApiError(error: any): Promise<never> {
  const payload = error?.response?.data;
  return Promise.reject(payload?.errors ?? payload ?? error?.message ?? error);
}
